// V2 Workflows — detailed step/vendor data for the workflows page

export const CHECK_BADGE = {
  "AML":                        { bg: "#fef3c7", color: "#92400e" },
  "DECISION":                   { bg: "#f3f4f6", color: "#374151" },
  "IDV":                        { bg: "#fce7f3", color: "#9d174d" },
  "KYC":                        { bg: "#dbeafe", color: "#1e40af" },
  "MATCHLIST":                  { bg: "#fee2e2", color: "#991b1b" },
  "TOGGLEMONITORING":           { bg: "#d1fae5", color: "#065f46" },
  "FRAUD":                      { bg: "#f3e8ff", color: "#6b21a8" },
  "SUPPORTING_DOCUMENTS_CHECK": { bg: "#e0e7ff", color: "#3730a3" },
  "VISA":                       { bg: "#fef9c3", color: "#854d0e" },
  "ENTITY_LOOKUP":              { bg: "#ccfbf1", color: "#134e4a" },
  "DUPLICATE":                  { bg: "#ffe4e6", color: "#9f1239" },
  "ORGANIZATIONDATAFETCH":      { bg: "#f0fdf4", color: "#166534" },
  "ORGANIZATIONPERSIST":        { bg: "#ecfdf5", color: "#065f46" },
  "REPORT":                     { bg: "#f5f3ff", color: "#5b21b6" },
  "ACTIVITY":                   { bg: "#fff7ed", color: "#9a3412" },
};

export const ORG_WORKFLOWS = [
  {
    name: "AUS Organization Profile",
    key: "AUS-Organization-Profile",
    steps: {
      AML: [{ name: "Run AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "PASS" },
        { name: "REVIEW" },
        { name: "FAIL" },
      ],
      ORGANIZATIONDATAFETCH: [
        { name: "ABR - Profile" },
        { name: "Creditorwatch" },
      ],
      ORGANIZATIONPERSIST: [{ name: "Persist Organization" }],
      REPORT: [{ name: "Generate Report" }],
    },
  },
  {
    name: "AUS Organization Ownership",
    key: "AUS-Organization-Ownership",
    steps: {
      AML: [{ name: "Run AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "COMPLETE" },
        { name: "REVIEW" },
        { name: "FAIL" },
      ],
      ORGANIZATIONDATAFETCH: [
        { name: "ABR - Profile" },
        { name: "Creditorwatch" },
      ],
      ORGANIZATIONPERSIST: [{ name: "Persist Organization" }],
      REPORT: [{ name: "Generate Report" }],
    },
  },
  {
    name: "AUS Organization AML",
    key: "AUS-Organization-AML",
    steps: {
      AML: [{ name: "ComplyAdvantage - AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "REVIEW" },
        { name: "FAIL" },
        { name: "PASS" },
      ],
    },
  },
  {
    name: "Domestic Profile",
    key: "Domestic Profile",
    steps: {
      DECISION: [{ name: "Update Workflow Result" }],
      ORGANIZATIONDATAFETCH: [
        { name: "ABR - Profile", vendor: "ABR" },
        { name: "CreditorWatch - Profile", vendor: "CREDITORWATCH" },
      ],
      ORGANIZATIONPERSIST: [{ name: "Persist Organization" }],
    },
  },
];

export const RECIPES = [
  {
    name: "Basic ID Only",
    key: "AUS-Basic1V-IDOnly",
    totalSteps: 15,
    vendors: ["dvs-docs", "manual", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "dvs-docs" },
        { name: "Testbed Docs", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Advanced 2-Source + ID",
    key: "AUS-Advanced2V-TwoPlus",
    totalSteps: 17,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "KYC Check (DVS)", vendor: "testbed-docs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "2+2 + Email/Phone (No AML)",
    key: "AUS-Basic1V-TwoPlus-Email-Phone-NoAML",
    totalSteps: 7,
    vendors: ["testbed", "testbed-fraud"],
    steps: {
      DECISION: [
        { name: "Update Workflow Result 4" },
        { name: "Workflow Result KYC/IDV FAIL" },
        { name: "Workflow Result Fraud REVIEW" },
        { name: "Workflow Result Fraud FAIL" },
      ],
      FRAUD: [{ name: "Sardine - Fraud Check (Email and Phone)", vendor: "testbed-fraud" }],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [{ name: "Equifax - KYC Check", vendor: "testbed" }],
    },
  },
  {
    name: "Standard 3-Source",
    key: "AUS-Basic3V-TwoPlus",
    totalSteps: 17,
    vendors: ["dvs-docs", "manual", "testbed", "testbed-2", "testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "dvs-docs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Equifax)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "ID Only + Supporting Docs",
    key: "AUS-Basic1V-IDOnly-SupDoc",
    totalSteps: 21,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Update Workflow Result 2" },
        { name: "Update Workflow Result" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "Testbed 1", vendor: "testbed" },
        { name: "Testbed 2", vendor: "testbed-2" },
        { name: "Testbed Docs", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      SUPPORTING_DOCUMENTS_CHECK: [{ name: "Support Document Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "2+2 + Device/Email/Phone (No AML)",
    key: "AUS-Basic1V-TwoPlus-Device-Email-Phone-NoAML",
    totalSteps: 7,
    vendors: ["sardine", "testbed"],
    steps: {
      DECISION: [
        { name: "Update Workflow Result 4" },
        { name: "Workflow Result KYC/IDV FAIL" },
        { name: "Workflow Result Fraud REVIEW" },
        { name: "Workflow Result Fraud FAIL" },
      ],
      FRAUD: [{ name: "Sardine - Fraud Check (Email and Phone)", vendor: "sardine" }],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [{ name: "Equifax - KYC Check", vendor: "testbed" }],
    },
  },
  {
    name: "Advanced 3-Source + Gov ID",
    key: "AUS-Advanced3V-TwoPlusID",
    totalSteps: 18,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "KYC Check (DVS)", vendor: "testbed-docs" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Equifax)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "AML-First",
    key: "AML-First",
    totalSteps: 9,
    vendors: ["manual", "testbed", "testbed-aml"],
    steps: {
      AML: [{ name: "Refinitiv - AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "REVIEW" },
        { name: "SUCCESS" },
        { name: "FAILED" },
        { name: "Matchlist - FAIL" },
      ],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "GDC One Plus", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Matchlist Check" }],
    },
  },
  {
    name: "Standard 2+2 + Gov ID",
    key: "AUS-Basic2V-TwoPlusID",
    totalSteps: 16,
    vendors: ["dvs-docs", "manual", "testbed", "testbed-2", "testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "dvs-docs" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Advanced ID + Biometrics",
    key: "AUS-Advanced1V-IDOnly",
    totalSteps: 19,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "IDV - NEEDS ATTENTION - Update Workflow Result" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "Testbed 1", vendor: "testbed" },
        { name: "Testbed 2", vendor: "testbed-2" },
        { name: "Testbed Docs", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Advanced ID Only + Visa",
    key: "AUS-Advanced1V-IDOnly-Visa",
    totalSteps: 16,
    vendors: ["manual", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
      VISA: [{ name: "Vevo Visa Check", vendor: "testbed-docs" }],
    },
  },
  {
    name: "3-Source + 1+ID + Visa",
    key: "AUS-Basic3V-OnePlusID",
    totalSteps: 13,
    vendors: ["datazoo", "manual", "testbed", "testbed-2", "testbed-docs"],
    steps: {
      DECISION: [
        { name: "IDV Fail/Unchecked" },
        { name: "KYC Workflow Result PASS" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      ENTITY_LOOKUP: [{ name: "Entity Information Lookup" }],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Equifax)", vendor: "testbed-2" },
        { name: "Datazoo - KYC Check", vendor: "datazoo" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      VISA: [{ name: "DVS Visa Check", vendor: "testbed-docs" }],
    },
  },
  {
    name: "Basic ID Only — Ongoing",
    key: "AUS-Basic1V-IDOnly - Ongoing",
    totalSteps: 15,
    vendors: ["manual", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
{
    name: "Standard 2+2 + Duplicate Check",
    key: "AUS-Basic2V-TwoPlus-Duplicate",
    totalSteps: 19,
    vendors: ["dvs-docs", "manual", "superchoice", "testbed-2", "testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Duplicate Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      DUPLICATE: [{ name: "Duplicate Check" }],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "dvs-docs" },
        { name: "Superchoice - KYC Check", vendor: "superchoice" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
{
    name: "DVS Only",
    key: "au-dvsonly",
    totalSteps: 3,
    vendors: ["dvs-docs"],
    steps: {
      DECISION: [
        { name: "Mark as PASS" },
        { name: "Mark as FAIL" },
      ],
      KYC: [{ name: "DVS Doc Only Check", vendor: "dvs-docs" }],
    },
  },
  {
    name: "Standard 2+2 (V2)",
    key: "AUS-Basic2V-TwoPlus",
    totalSteps: 16,
    vendors: ["dvs", "manual", "testbed", "testbed-2", "testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "dvs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Global 1-Source+",
    key: "GLB-Basic1V-OnePlus",
    totalSteps: 32,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "ComplyAdvantage - AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "RISK LOW" },
        { name: "RISK HIGH" },
        { name: "AML REVIEW" },
        { name: "AML FAIL" },
        { name: "KYC FAIL" },
        { name: "Matchlist - WF Fail" },
      ],
      ENTITY_LOOKUP: [{ name: "Entity Information Lookup" }],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "Centrix - KYC Check", vendor: "testbed-docs" },
        { name: "AsiaVerify GovID KYC Check - CHN", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - CHN", vendor: "testbed-docs" },
        { name: "AsiaVerify GovID KYC Check - IND", vendor: "testbed-docs" },
        { name: "Monnai Government KYC Check - IND", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - IND", vendor: "testbed-docs" },
        { name: "Socure - KYC Check", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - USA", vendor: "testbed-docs" },
        { name: "AdvanceAI KYC Check", vendor: "testbed-docs" },
        { name: "Monnai Government KYC Check - PHL", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - PHL", vendor: "testbed-docs" },
        { name: "Netbay DOPA KYC Check", vendor: "testbed-docs" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - AUS", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - OTHR", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check", vendor: "testbed" },
        { name: "GDC One Plus - KYC Check 2", vendor: "testbed-2" },
      ],
      MATCHLIST: [{ name: "Run a Matchlist Check" }],
      TOGGLEMONITORING: [
        { name: "Toggle Monitoring OFF 3" },
        { name: "Toggle Monitoring OFF 2" },
        { name: "Toggle Monitoring OFF 5" },
        { name: "Toggle Monitoring OFF" },
      ],
    },
  },
  {
    name: "India ID Only",
    key: "IND-Basic1V-IDOnly",
    totalSteps: 18,
    vendors: ["asiaverify_gov_id_2", "manual", "monnai_government", "testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      ENTITY_LOOKUP: [{ name: "Entity Information Lookup" }],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "AsiaVerify GovID 2 KYC Check", vendor: "asiaverify_gov_id_2" },
        { name: "Monnai Government KYC Check", vendor: "monnai_government" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
        { name: "Toggle Monitoring" },
      ],
    },
  },
{
    name: "3-Source + 2+2 + ID + Age",
    key: "AUS-Basic3V-TwoPlusIDAge",
    totalSteps: 18,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Equifax)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Global 1-Source+ Address Verify",
    key: "GLB-Basic1V-OnePlusAddressVerify",
    totalSteps: 30,
    vendors: ["manual", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "ComplyAdvantage - AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "RISK LOW" },
        { name: "RISK HIGH" },
        { name: "AML REVIEW" },
        { name: "AML FAIL" },
        { name: "KYC FAIL" },
        { name: "Matchlist - WF Fail" },
      ],
      ENTITY_LOOKUP: [{ name: "Entity Information Lookup" }],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "Centrix - KYC Check", vendor: "testbed-docs" },
        { name: "AsiaVerify GovID KYC Check - CHN", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - CHN", vendor: "testbed-docs" },
        { name: "AsiaVerify GovID KYC Check - IND", vendor: "testbed-docs" },
        { name: "Monnai Government KYC Check", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - IND", vendor: "testbed-docs" },
        { name: "Socure - KYC Check", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - USA", vendor: "testbed-docs" },
        { name: "AdvanceAI KYC Check", vendor: "testbed-docs" },
        { name: "Monnai Government KYC Check 2", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - PHL", vendor: "testbed-docs" },
        { name: "Netbay DOPA KYC Check", vendor: "testbed-docs" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - AUS", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - OTHR", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Matchlist Check" }],
      TOGGLEMONITORING: [
        { name: "Toggle Monitoring OFF 3" },
        { name: "Toggle Monitoring OFF 2" },
        { name: "Toggle Monitoring OFF 5" },
        { name: "Toggle Monitoring OFF" },
      ],
    },
  },
  {
    name: "Basic Monitoring — TxAM",
    key: "Basic-Monitoring-TxAM",
    totalSteps: 5,
    vendors: [],
    steps: {
      ACTIVITY: [
        { name: "Fraud Transaction & Activity Monitoring" },
        { name: "AML Transaction Monitoring" },
      ],
      DECISION: [
        { name: "Mark Workflow REVIEW" },
        { name: "Mark Workflow CLEAR" },
        { name: "Mark Workflow FAIL" },
      ],
    },
  },
  {
    name: "Global AML Advanced",
    key: "GLB-AML-Advanced",
    totalSteps: 10,
    vendors: ["testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "3-Source + 2+2 + Address",
    key: "AUS-Basic3V-TwoPlusAddress",
    totalSteps: 18,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Equifax)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Global 1-Source+ DOB Verify",
    key: "GLB-Basic1V-OnePlusDobVerify",
    totalSteps: 30,
    vendors: ["manual", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "ComplyAdvantage - AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "RISK LOW" },
        { name: "RISK HIGH" },
        { name: "AML REVIEW" },
        { name: "AML FAIL" },
        { name: "KYC FAIL" },
        { name: "Matchlist - WF Fail" },
      ],
      ENTITY_LOOKUP: [{ name: "Entity Information Lookup" }],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "Centrix - KYC Check", vendor: "testbed-docs" },
        { name: "AsiaVerify GovID KYC Check - CHN", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - CHN", vendor: "testbed-docs" },
        { name: "AsiaVerify GovID KYC Check - IND", vendor: "testbed-docs" },
        { name: "Monnai Government KYC Check", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - IND", vendor: "testbed-docs" },
        { name: "Socure - KYC Check", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - USA", vendor: "testbed-docs" },
        { name: "AdvanceAI KYC Check", vendor: "testbed-docs" },
        { name: "Monnai Government KYC Check 2", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - PHL", vendor: "testbed-docs" },
        { name: "Netbay DOPA KYC Check", vendor: "testbed-docs" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - AUS", vendor: "testbed-docs" },
        { name: "GDC One Plus - KYC Check - OTHR", vendor: "testbed-docs" },
      ],
      MATCHLIST: [{ name: "Run a Matchlist Check" }],
      TOGGLEMONITORING: [
        { name: "Toggle Monitoring OFF 3" },
        { name: "Toggle Monitoring OFF 2" },
        { name: "Toggle Monitoring OFF 5" },
        { name: "Toggle Monitoring OFF" },
      ],
    },
  },
  {
    name: "USA 1-Source+",
    key: "USA-Basic1V-OnePlus",
    totalSteps: 17,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "ComplyAdvantage - AML Check", vendor: "testbed-aml" }],
      DECISION: [
        { name: "RISK LOW" },
        { name: "RISK HIGH" },
        { name: "AML REVIEW" },
        { name: "AML FAIL" },
        { name: "KYC FAIL" },
        { name: "Matchlist - WF Fail" },
      ],
      IDV: [{ name: "IDV Full Bio" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "Testbed 1", vendor: "testbed-docs" },
        { name: "Datazoo - KYC Check", vendor: "testbed" },
        { name: "Socure - KYC Check", vendor: "testbed-2" },
      ],
      MATCHLIST: [{ name: "Run a Matchlist Check" }],
      TOGGLEMONITORING: [
        { name: "Toggle Monitoring OFF 3" },
        { name: "Toggle Monitoring OFF 2" },
        { name: "Toggle Monitoring OFF 5" },
        { name: "Toggle Monitoring OFF" },
      ],
    },
  },
{
    name: "3-Source + 2+2 + ID",
    key: "AUS-Basic3V-TwoPlusID",
    totalSteps: 18,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Equifax)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Basic ID Only + Visa",
    key: "AUS-Basic1V-IDOnly-Visa",
    totalSteps: 17,
    vendors: ["dvs-docs", "manual", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "DVS - KYC Check - Documents Only DVS Testbed", vendor: "dvs-docs" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
      VISA: [{ name: "Vevo Visa Check", vendor: "testbed-docs" }],
    },
  },
  {
    name: "3-Source + 2+2 + Age",
    key: "AUS-Basic3V-TwoPlusAge",
    totalSteps: 18,
    vendors: ["manual", "testbed", "testbed-2", "testbed-aml", "testbed-docs"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
        { name: "KYC Workflow Result FAIL" },
        { name: "Blocklist Workflow Result FAIL" },
      ],
      IDV: [{ name: "IDV/Bio Check" }],
      KYC: [
        { name: "Manual KYC", vendor: "manual" },
        { name: "DVS - KYC Check - Documents Only", vendor: "testbed-docs" },
        { name: "KYC Check (Superchoice)", vendor: "testbed" },
        { name: "KYC Check (Experian)", vendor: "testbed-2" },
        { name: "KYC Check (Equifax)", vendor: "testbed" },
      ],
      MATCHLIST: [{ name: "Run a Blocklist Check" }],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
        { name: "KYC Fail - Monitoring OFF" },
      ],
    },
  },
  {
    name: "Global AML Basic",
    key: "GLB-AML-Basic",
    totalSteps: 8,
    vendors: ["testbed-aml"],
    steps: {
      AML: [{ name: "AML Check (ComplyAdvantage)", vendor: "testbed-aml" }],
      DECISION: [
        { name: "Low Risk - Workflow PASS" },
        { name: "High Risk - Workflow FAIL" },
        { name: "AML Workflow Result REVIEW" },
        { name: "AML Workflow Result FAIL" },
      ],
      TOGGLEMONITORING: [
        { name: "All Checks - Monitoring ON" },
        { name: "High Risk - Monitoring OFF" },
        { name: "AML Fail - Monitoring OFF" },
      ],
    },
  },
];
